import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from 'DesignSystem/Buttons';

const LandingPageFullWidthUploadPanelCTA = props => (
  <div
    className="large-upload-panel-cta-wrapper"
    id={props.ctaId}
    onClick={props.ctaOnClick}
  >
    <PrimaryButton className="large-upload-panel-cta-button" onClick={() => {}}>
      {props.ctaText}
    </PrimaryButton>
  </div>
);

LandingPageFullWidthUploadPanelCTA.defaultProps = {
  ctaOnClick: () => {},
  ctaText: '',
};

LandingPageFullWidthUploadPanelCTA.propTypes = {
  ctaId: PropTypes.string.isRequired,
  ctaOnClick: PropTypes.func,
  ctaText: PropTypes.string,
};

export default LandingPageFullWidthUploadPanelCTA;



// WEBPACK FOOTER //
// ./src-react/LandingPageFullWidthUploadPanelCTA/index.jsx